module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page rowBackgroundHomepage"
  }, [(_vm.isSmartphoneOS) ? _c('div', [(false) ? _c('f7-navbar', {
    staticStyle: {
      "position": "absolute",
      "top": "44px"
    }
  }, [_c('b-row', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', [_c('f7-button', {
    staticClass: "statusButton",
    class: _vm.currentRole === 'simple' ? 'navbar-button-selected' : 'navbar-button',
    attrs: {
      "round": "",
      "tab-link": ".contactTab1"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.contacts_label')) + "\n            ")])], 1), _vm._v(" "), _c('b-col', [_c('f7-button', {
    staticClass: "statusButton",
    class: _vm.currentRole === 'group' ? 'navbar-button-selected' : 'navbar-button',
    attrs: {
      "round": "",
      "tab-link": ".contactTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.groups_label')) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSmartphoneOS) ? _c('f7-searchbar', {
    staticClass: "search",
    staticStyle: {
      "position": "absolute",
      "top": "44px",
      "width": "100%",
      "z-index": "10"
    },
    attrs: {
      "id": "searchBankAccount",
      "cancel-link": _vm.$t('common.cncl'),
      "search-list": "#bank-list",
      "placeholder": _vm.searchInLabel
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly"
  }, [(_vm.currentRole === 'simple') ? _c('f7-fab', {
    staticClass: "leftfav3 button-fab bottomButton",
    on: {
      "click": _vm.OpenFormsPageContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('f7-fab', {
    staticClass: "leftfav3 button-fab bottomButton",
    on: {
      "click": _vm.OpenFormsPageContactGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 bottomButton",
    attrs: {
      "href": "/contact/import"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "bullet_list"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.contacts, _vm.contactGroups)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1), _vm._v(" "), (_vm.multipleContactsDelete.length > 0) ? _c('f7-fab', {
    staticClass: "button-fab bottomButton contactDeleteButtonPosition",
    attrs: {
      "id": "contactDeleteButton"
    },
    on: {
      "click": _vm.deleteMultipleContacts
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "trash"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(!_vm.isSmartphoneOS) ? _c('div', {
    staticClass: "layoutTop"
  }) : (false) ? _c('div', {
    staticStyle: {
      "height": "132px"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "88px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "listPage"
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start showLargeScreenOnly"
  }, [(_vm.currentRole === 'simple') ? _c('b-col', {
    attrs: {
      "sm": "3",
      "xl": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.canAdd
    },
    on: {
      "click": _vm.OpenFormsPageContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.add_label')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentRole === 'group') ? _c('b-col', {
    attrs: {
      "sm": "3",
      "xl": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.OpenFormsPageContactGroup
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.add_label')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.contacts, _vm.contactGroups)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.extract')))])], 1)], 1)], 1), _vm._v(" "), (!_vm.isSmartphoneOS && false) ? _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "contactButtonContainer"
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink",
    class: {
      tabActive: _vm.currentRole === 'simple', tabUnactive: _vm.currentRole !== 'simple'
    },
    staticStyle: {
      "border-top-left-radius": "10px"
    },
    attrs: {
      "tab-link": ".contactTab1",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('simple')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.contacts_label')) + "\n                  ")])], 1), _vm._v(" "), _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink",
    class: {
      tabActive: _vm.currentRole === 'group', tabUnactive: _vm.currentRole !== 'group'
    },
    staticStyle: {
      "border-top-right-radius": "10px"
    },
    attrs: {
      "tab-link": ".contactTab2"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('group')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.groups_label')) + "\n                  ")])], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', [_c('f7-tabs', [_c('f7-tab', {
    staticClass: "contactTab1",
    attrs: {
      "active": ""
    }
  }, [(!_vm.isSmartphoneOS) ? _c('f7-searchbar', {
    staticClass: "search webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contacts-list",
      "placeholder": _vm.searchInLabel,
      "clear-button": true
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "itemList"
  }, [_c('cm-contact-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "contacts": _vm.contacts
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  })], 1)], 1), _vm._v(" "), _c('f7-tab', {
    staticClass: "contactTab2"
  }, [(!_vm.isSmartphoneOS) ? _c('f7-searchbar', {
    staticClass: "webdatalist",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#group-list",
      "placeholder": _vm.searchInLabel
    },
    on: {
      "searchbar:search": _vm.onGroupSearch,
      "searchbar:clear": _vm.onGroupClear
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "itemList"
  }, [_c('cm-contact-group-list', {
    attrs: {
      "filterBy": _vm.groupFilterBy,
      "contactGroups": _vm.contactGroups
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObjectGroup.firstIndex,
      "maxResultsByPage": _vm.paginationObjectGroup.maxResults,
      "nbResultsTotal": _vm.paginationObjectGroup.nbResultsTotal,
      "refreshEvent": _vm.paginationObjectGroup.refresh
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06313d4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06313d4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactsPage.vue
// module id = 2319
// module chunks = 2